import script from "./SearchVariables.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchVariables.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__